import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../../methods/methods';
import { roleType, userType } from '../../../models/type.model';
import Html from './Html';
import { useNavigate, useParams } from 'react-router-dom';
import environment from '../../../environment';
import { FaMobile } from 'react-icons/fa';

const AddEditSubAdmin = () => {
  const { role, id } = useParams();
  const [images, setImages] = useState({ image: '' });
  const [PermissionId, setPermissionID] = useState('');
  const defaultvalue = userType;
  const [form, setform] = useState({
    firstName: '',
    lastName: '',
    email: '',
    gender: '',
    mobileNo: '',
    dialCode: '',
    image: '',
    address: '',
    permissions: {
      user_get: false,
      user_delete: false,
      user_edit: false,
      user_add: false,
      user_complete_access: false,
      category_get: false,
      category_delete: false,
      category_edit: false,
      category_add: false,
      category_complete_access: false,
      blog_get: false,
      blog_delete: false,
      blog_edit: false,
      blog_add: false,
      blog_complete_access: false,
      course_get: false,
      course_delete: false,
      course_edit: false,
      course_add: false,  
      course_complete_access: false,
    },
  });
  const [eyes, setEyes] = useState({ password: false, confirmPassword: false });
  const [submitted, setSubmitted] = useState(false);
  const history = useNavigate();
  const [roles, setRoles] = useState([]);
  const [emailLoader, setEmailLoader] = useState(false);
  const [emailErr, setEmailErr] = useState('');
  const [detail, setDetail] = useState();
  const user = useSelector((state) => state.user);
  const formValidation = [
    { key: 'email', email: true },
    { key: 'lastName', required: true },
    { key: 'firstName', required: true },
    { key: 'mobileNo', required: true },

    // { key: 'ic_number', minLength: 6 },
    // { key: 'password', minLength: 8 },
    // {
    //   key: 'confirmPassword',
    //   minLength: 8,
    //   confirmMatch: ['confirmPassword', 'password'],
    // },
  ];


  const getError = (key) => {
    return methodModel.getError(key, form, formValidation);
  };

  const getPermission = () => {
    ApiClient.get('permission/user-base', { user_id: user?.id }).then((res) => {
      if (res?.success) {
        setform({
          ...form,
          permissions: {
            user_add: res?.data?.user_add,
            user_edit: res?.data?.user_edit,
            user_delete: res?.data?.user_delete,
            user_get: res?.data?.user_get,
            user_complete_access: res?.data?.user_complete_access,
            category_get: res?.data?.category_get,
            category_delete: res?.data?.category_delete,
            category_edit: res?.data?.category_edit,
            category_add: res?.data?.category_add,
            category_complete_access: res?.data?.category_complete_access,
            blog_get: res?.data?.blog_get,
            blog_delete: res?.data?.blog_delete,
            blog_edit: res?.data?.blog_edit,
            blog_add: res?.data?.blog_add,
            blog_complete_access: res?.data?.blog_complete_access,
            course_get: res?.data?.course_get,
            course_delete: res?.data?.course_delete,
            course_edit: res?.data?.course_edit,
            course_add: res?.data?.course_add,
            course_complete_access: res?.data?.course_complete_access,
            id: res?.data?.id,
          },
        });
      }
    });
  };

  const ExtractMobileNo = (key) => {
    let i = form?.dialCode?.length;
    let e = form?.mobileNo?.length;
    let Extract = form?.mobileNo?.substr(i + 1, e);
  };
  // console.log(form,"hsdgf")
  // return
  const handleSubmit = (e) => {

    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    // console.log(form,"coleefffffff")
    // return
    if (invalid) return;
    let method = 'post';
    let url = 'admin/add-user';
    let value = {
      firstName: form?.firstName,
      lastName: form?.lastName,
      mobileNo: form?.mobileNo,
      dialCode: form?.dialCode,
      gender: form?.gender,
      email: form?.email,
      permissions: form?.permissions,
      // permissions: form?.permissions._id ||form?.permissions.id,
      image: form?.image,
      role: 'subadmin',
    };
    if (id) {
      method = 'put';
      url = 'admin/edit-user';
      value.id = JSON.parse(id);
      value.permissions = { ...form?.permissions };
      delete value?.role;
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        let url = '/sub-admin';
        if (role) url = '/users/' + role;
        history(url);
      }
      loader(false);
    });
  };

  const imageResult = (e, key) => {
    images[key] = e.value;
    setImages(images);
    setform({ ...form, image: e.value });
    console.log('imageResult', e);
  };

  const addressResult = (e) => {
    setform({ ...form, address: e.value });
  };

  const back = () => {
    history(-1);
  };

  const getRoles = () => {
    ApiClient.get('role/all', { status: 'active' }).then((res) => {
      if (res.success) {
        let data = res.data;
        data = data.filter((itm) => itm.id != environment.userRoleId);
        setRoles(data);
      }
    });
  };

  const emailCheck = (email) => {
    return;
    let isValid = methodModel.emailvalidation(email);
    if (isValid) {
      setEmailLoader(true);
      ApiClient.get('api/check/email', { email: email }).then((res) => {
        if (!res.success) {
          if (detail?.email != email) {
            setEmailErr(res.error.message);
          }
        } else {
          setEmailErr('');
        }
        setEmailLoader(false);
      });
    } else {
    }
  };

  useEffect(() => {
    setSubmitted(false);

    if (id) {
      loader(true);
      ApiClient.get('user/detail', { id }).then((res) => {
        if (res.success) {
          let value = res?.data;
          setDetail(res?.data);
          
          setform({ ...form, ...res?.data });
          ApiClient.get('permission/user-base', { user_id: id }).then(
            (resp) => {
              if (resp?.success) {
                value = {
                  ...value,
                  permissions: {
                    user_add: resp?.data?.user_add,
                    user_edit: resp?.data?.user_edit,
                    user_delete: resp?.data?.user_delete,
                    user_get: resp?.data?.user_get,
                    user_complete_access: resp?.data?.user_complete_access,
                    category_get: resp?.data?.category_get,
                    category_delete: resp?.data?.category_delete,
                    category_edit: resp?.data?.category_edit,
                    category_add: resp?.data?.category_add,
                    category_complete_access:
                      resp?.data?.category_complete_access,
                    blog_get: resp?.data?.blog_get,
                    blog_delete: resp?.data?.blog_delete,
                    blog_edit: resp?.data?.blog_edit,
                    blog_add: resp?.data?.blog_add,
                    blog_complete_access: resp?.data?.blog_complete_access,
                    course_get: resp?.data?.course_get,
                    course_delete: resp?.data?.course_delete,
                    course_edit: resp?.data?.course_edit,
                    course_add: resp?.data?.course_add,
                    course_complete_access: resp?.data?.course_complete_access,
                    // id: resp?.data?.id,
                  },
                };
                setPermissionID(resp?.data?.id);
                setform(value);
                // setform({
                //   ...form,
                //   permissions: {
                //     user_add: res?.data?.user_add,
                //     user_edit: res?.data?.user_edit,
                //     user_delete: res?.data?.user_delete,
                //     user_get: res?.data?.user_get,
                //     user_complete_access: res?.data?.user_complete_access,
                //     id: res?.data?.id,
                //   },
                // });
              }
            }
          );
        }

        loader(false);
      });
    }

    // getRoles();
  }, [id]);

  console.log(detail,'dd')
  useEffect(() => {
    if (id) {
      // getPermission();
    }
  }, [id]);

  return (
    <>
      <Html
        form={form}
        detail={detail}
        emailCheck={emailCheck}
        emailLoader={emailLoader}
        emailErr={emailErr}
        back={back}
        setEyes={setEyes}
        eyes={eyes}
        role={role}
        setform={setform}
        roles={roles}
        submitted={submitted}
        images={images}
        addressResult={addressResult}
        handleSubmit={handleSubmit}
        imageResult={imageResult}
        getError={getError}
        id={id}
      />
    </>
  );
};

export default AddEditSubAdmin;
